import { ConfigContext } from "../../App";
import { EventFilterProp } from '../../proptype'
import React,{ useContext, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

export default function EventFilter(props: EventFilterProp) {

    const locales = useContext(ConfigContext).appConfig.languageData;

    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                ReactTooltip.hide();
            }
        };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, []);

    const eventFilterList: any = [{
        name: locales.all_event,
        cssClassName: 'all'
    }, {
        name: locales.major,
        cssClassName: 'major'
    }, {
        name: locales.minor,
        cssClassName: 'minor'
    }, {
        name: locales.potential,
        cssClassName: 'potential'
    }, {
        name: locales.maintenance,
        cssClassName: 'maintenance'
    },{
        name: locales.announcement,
        cssClassName: 'announcement'
    }];

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="event-filters desktop">
                    <div className="filter-container" role="group" aria-label="Event type filters">
                        {eventFilterList.map((eventType: any, index: number) =>
                            <div 
                                className={props.active === eventType.cssClassName ? `${eventType.cssClassName} event-icon active` : `${eventType.cssClassName} event-icon`} 
                                key={index} 
                                onClick={() => { props.onEventFilter(eventType.cssClassName); }}
                                tabIndex={0}
                                role="button"
                                aria-pressed={props.active === eventType.cssClassName}
                                aria-label={`Filter by ${eventType.name}, ${props.active === eventType.cssClassName ? 'selected' : 'not selected'}`}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        props.onEventFilter(eventType.cssClassName);
                                    }
                                }}
                            >
                                {eventType.name}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
